import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Box from '../Box';

var DialogActions =
/*#__PURE__*/
_styled(Box, {
  target: "e1m4bfno0"
})(process.env.NODE_ENV === "production" ? {
  name: "yrhaku",
  styles: "display:flex;align-items:center;justify-content:flex-end;>:not(:first-of-type){margin-left:8px;}"
} : {
  name: "yrhaku",
  styles: "display:flex;align-items:center;justify-content:flex-end;>:not(:first-of-type){margin-left:8px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9EaWFsb2cvRGlhbG9nQWN0aW9ucy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHaUMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL0RpYWxvZy9EaWFsb2dBY3Rpb25zLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IEJveCBmcm9tICcuLi9Cb3gnO1xuXG5jb25zdCBEaWFsb2dBY3Rpb25zID0gc3R5bGVkKEJveClgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gID4gOm5vdCg6Zmlyc3Qtb2YtdHlwZSkge1xuICAgIG1hcmdpbi1sZWZ0OiA4cHg7XG4gIH1cbmA7XG5cbkRpYWxvZ0FjdGlvbnMuZGVmYXVsdFByb3BzID0ge1xuICBwdDogMixcbn07XG5cbmV4cG9ydCBkZWZhdWx0IERpYWxvZ0FjdGlvbnM7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

DialogActions.defaultProps = {
  pt: 2
};
export default DialogActions;